import { useEffect } from 'react';

export const TermsPage = () => {
  useEffect(() => {
    document.title = 'Termos de Uso – Joyn';
  }, []);

  return (
    <div className="min-h-screen bg-background py-10 px-4">
      <div className="max-w-2xl mx-auto">
        <div className="bg-card border border-border rounded-xl px-8 py-10 shadow-sm">
          <div className="flex flex-col items-center mb-8 text-center">
            <img src="/logo_eventfy.png" alt="Joyn" className="w-48 h-auto object-contain mb-6" />
            <h1 className="text-xl font-semibold text-foreground">Termos de Uso – Joyn</h1>
          </div>

          <p className="text-sm text-muted-foreground leading-relaxed text-center">
            Os Termos de Uso do Joyn estarão disponíveis em breve.
          </p>
        </div>
      </div>
    </div>
  );
};
